import React, { useMemo } from 'react';
import Select from 'react-select';

const AttractionInclusion = ({
    disabled,
    attractionList,
    formvalue,
    handleSelectAttraction,
    InputOption,
    attractionDetailShow,
    setAttractionDetailShow,
    attractionDetail
}) => {
    const selectedAttractions = useMemo(() => {
        if (!formvalue?.AttractionBasicId?.length) return [];
        return attractionList?.filter(list => formvalue.AttractionBasicId.includes(list?.value)) || [];
    }, [attractionList, formvalue?.AttractionBasicId]);

    return (
        <>
            <div className="col-lg-12 col-sm-6">
                <div className="row">
                    <div className="col-lg-2 col-md-12 mb-1">
                        <label className="col-form-label">Add Attraction</label>
                    </div>
                    <div className="col-lg-4 mb-1 col-md-12">
                        <Select
                            className="dropdown select_dropdown"
                            options={attractionList}
                            value={selectedAttractions}
                            onChange={handleSelectAttraction}
                            isDisabled={disabled}
                            isSearchable
                            isMulti
                            components={{
                                Option: InputOption
                            }}
                            hideSelectedOptions={false}
                            closeMenuOnSelect={false}
                        />
                    </div>
                    <div className="col-lg-2 mb-1 col-md-12">
                        <button
                            type="button"
                            className="btn btn-primary mx-1"
                            onClick={() => setAttractionDetailShow(!attractionDetailShow)}
                        >
                            <i className={`fa fa-plus ${attractionDetailShow ? "fa-minus" : "fa-plus"}`} aria-hidden="true"></i>
                        </button>
                    </div>
                </div>
            </div>

            {attractionDetailShow && (
                <div className="col-lg-12 col-sm-12 mt-3 mb-2 py-2 form_border ms-2">
                    <div className="row">
                        <div className="col-lg-12 mb-1 table-scrollable">
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th>Attraction Name</th>
                                        <th>Attraction Type</th>
                                        <th>Attraction Category</th>
                                        <th>Attraction Theme</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {attractionDetail?.map((item) => (
                                        <tr key={item?.value}>
                                            <td>{item?.label}</td>
                                            <td>{item?.type}</td>
                                            <td>{item?.category}</td>
                                            <td>{item?.theme}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default React.memo(AttractionInclusion);

